





































import {
  defineComponent,
  ref,
  useContext,
  onMounted,
  onUpdated,
  useRoute,
} from '@nuxtjs/composition-api';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import { Breadcrumb } from '~/modules/catalog/types';
import { SfHeading } from '@storefront-ui/vue';
import SfBreadcrumbs from "~/components/Sf/SfBreadcrumbs.vue";
import { useCms, useGtm } from '~/composables';
import { usePageStore } from '~/stores/page';
import { isEmpty, concat, join, map, assign, trimEnd } from 'lodash-es';
import Utils from '~/helpers/utils';

export default defineComponent({
  name: 'SearchResult',
  components: {
    SfHeading,
    SfBreadcrumbs
  },
  setup() {
    const pageStore = usePageStore();
    const { eventPageLoad, eventSearchResults, eventCustomlinksInteracted } = useGtm();
    const { localePath, app: { i18n, $config } } = useContext();
    const route = useRoute();
    const pageMetaData = ref({
      meta_title: join([i18n.t('Search Result'), $config.defaultMetaTitle], ' | '),
      meta_description: i18n.t('Search Result'),
      meta_keyword: i18n.t('Search Result'),
      pageTitle: i18n.t('Search Result'),
      metaDescription: i18n.t('Search Result'),
      pageUrl: trimEnd($config.baseUrl, '/') + route.value.path,
    });
    const { preventXSSAttacks } = Utils();
    const breadcrumbs = ref<Breadcrumb[]>([]);
    const keyword = ref('');
    const { searchCms } = useCms();
    const searchResult = ref([]);
    const searchCount = ref(0);
    const currentPage = ref(1);
    const totalPage = ref(1);

    onUpdated(() => {
      document.body.classList.remove('show-hero-img');
    });
    onMounted(async () => {
      document.body.classList.remove('show-hero-img');
      breadcrumbs.value = [
        {
          text: i18n.t('Home') as string,
          link: localePath('/'),
        },
        {
          text: i18n.t('Site Search') as string,
          link: 'javascript:void(0)',
        }
      ];

      keyword.value = String(route.value.query.query);
      const data = await loadSearchResult(keyword.value, currentPage.value);
      if (data['total_count']) {
        searchCount.value = data['total_count'];
      }
      if (data['total_page']) {
        totalPage.value = data['total_page'];
      }
      if (!isEmpty(data['data'])) {
        searchResult.value = data['data'];
      }
      pageStore.$patch((state) => {
        state.pageData = assign(state.pageData, {
          pageName: i18n.t('Search Result'),
          pageTitle: i18n.t('Search Result'),
          pageCategory: join(map(breadcrumbs.value, (item) => item.text), '/'),
          breadCrumbs: map(breadcrumbs.value, (item) => item.text),
        });
      });
      eventPageLoad();
      eventSearchResults({
        "SearchTerm": keyword.value,
        "SearchResults": data['data'],
      });
    });

    const loadSearchResult = async (keyword, page) => {
      const searchKeyword = preventXSSAttacks(keyword);
      if (searchKeyword.length > 0) {
        return await searchCms({
          keyword: searchKeyword,
          page: page,
          pageSize: 15
        });
      }
    };
    const loadMoreResult = async () => {
      if (currentPage.value < totalPage.value) {
        currentPage.value++;
        const data = await loadSearchResult(keyword.value, currentPage.value);
        if (!isEmpty(data['data'])) {
          searchResult.value = concat(searchResult.value, data['data']);
        }
        eventSearchResults({
          "Search Category": "Global Search",
          "SearchTerm": keyword.value,
          "SearchResults": data['data'],
        });
      }
    };

    return {
      pageMetaData,
      currentPage,
      totalPage,
      keyword,
      breadcrumbs,
      searchResult,
      searchCount,
      loadMoreResult,
      eventCustomlinksInteracted,
    };
  },
  head() {
    return getMetaInfo(this.pageMetaData);
  },
});
